// import React from 'react';
import { Availability } from '@firsttable/web-components/organisms';
import withBooking from '../../../hocs/booking';

export default withBooking(Availability);
